// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mask-skew[data-v-241ffd4a]{-webkit-transform:skewY(-15deg);transform:skewY(-15deg)}.art-skew[data-v-241ffd4a]{-webkit-transform:skewY(15deg);transform:skewY(15deg);position:relative;top:-15%}", ""]);
// Exports
module.exports = exports;
